(() => {
  const FORM = '.st_pi-form';
  const ready = new WeakSet();
  const showIfCartHasItems = (actions) => {
    fetch('/cart.js', {credentials: 'same-origin'})
      .then((r) => r.ok ? r.json() : null)
      .then((cart) => { if (cart && Number(cart.item_count) > 0) actions.hidden = false; })
      .catch(() => {});
  };
  const setup = (form) => {
    if (ready.has(form)) return;
    const atc = form.querySelector('[data-st-atc], .st_pi-atc');
    if (!atc) return;
    ready.add(form);
    const actions = document.createElement('div');
    actions.className = 'hearthline-cart-actions';
    actions.hidden = true;
    const checkout = document.createElement('a');
    checkout.className = 'hearthline-checkout-button';
    checkout.href = '/checkout';
    checkout.textContent = 'Proceed to checkout';
    checkout.setAttribute('aria-label', 'Proceed to checkout');
    const cart = document.createElement('a');
    cart.className = 'hearthline-view-cart-button';
    cart.href = '/cart';
    cart.textContent = 'View cart';
    cart.setAttribute('aria-label', 'View cart');
    actions.append(checkout, cart);
    atc.insertAdjacentElement('afterend', actions);
    const reveal = () => window.setTimeout(() => showIfCartHasItems(actions), 900);
    atc.addEventListener('click', reveal);
    form.addEventListener('submit', reveal, true);
    showIfCartHasItems(actions);
  };
  const scan = () => document.querySelectorAll(FORM).forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, {once: true}); else scan();
  new MutationObserver(scan).observe(document.documentElement, {childList: true, subtree: true});
})();
